import { useState } from 'react';
import { useConvex } from 'convex/react';
import { api } from '../../../../convex/_generated/api';

/**
 * "Export everything, any time, CSV." It is a promise on the landing page and the ethical
 * counter to the lock-in this market is used to, so it is a button, not a support ticket.
 */
export default function Exports() {
  const convex = useConvex();
  const [busy, setBusy] = useState<string | null>(null);

  async function download(which: 'register' | 'tests') {
    setBusy(which);
    try {
      const result =
        which === 'register'
          ? await convex.query(api.reports.exportRegister, {})
          : await convex.query(api.reports.exportTests, {});
      const blob = new Blob([result.csv], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = result.filename;
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setBusy(null);
    }
  }

  return (
    <>
      <h1>Exports</h1>
      <div className="card">
        <strong>Asset register</strong>
        <p className="muted small">
          Every item you have on record: tag, description, location, class, environment,
          status, last tested and next due.
        </p>
        <button disabled={busy !== null} onClick={() => void download('register')}>
          {busy === 'register' ? 'Preparing…' : 'Download register CSV'}
        </button>
      </div>

      <div className="card">
        <strong>Test history</strong>
        <p className="muted small">
          Every test ever recorded, with technician and tester serial — the columns an
          auditor asks for.
        </p>
        <button disabled={busy !== null} onClick={() => void download('tests')}>
          {busy === 'tests' ? 'Preparing…' : 'Download test history CSV'}
        </button>
      </div>

      <div className="card">
        <p className="muted small">
          Your data is yours. These exports are complete, not samples, and they are available
          on every plan including while a subscription is lapsed.
        </p>
      </div>
    </>
  );
}
